import 'vite/modulepreload-polyfill' // eslint-disable-line

import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import * as Sentry from '@sentry/react'

import { AriaLiveProvider } from 'js/components/AriaLive'
import client from 'js/lib/client'
import { GlobalStateProvider } from 'js/lib/withGlobalState'
import SearchProvider from 'js/search/providers/SearchProvider'

import '../less/style.less'
import App from './App'
import insertDomElement from './lib/insertDomElement'

const container = document.querySelector('#react-root')

const render = (Component) => {
    const root = createRoot(container) // createRoot(container!) if you use TypeScript
    root.render(
        <ApolloProvider client={client}>
            <GlobalStateProvider>
                <AriaLiveProvider>
                    <SearchProvider>
                        <Component />
                    </SearchProvider>
                </AriaLiveProvider>
            </GlobalStateProvider>
        </ApolloProvider>,
    )
}

insertDomElement({
    attr: { id: 'modal-root' },
    after: container,
})

render(App)

Sentry.init({
    dsn: import.meta.env.SENTRY_DSN,
    enabled: import.meta.env.MODE !== 'development',
    tracesSampleRate: import.meta.env.SENTRY_TRACES_SAMPLE_RATE,
    profilesSampleRate: import.meta.env.SENTRY_PROFILING_SAMPLING_RATE,
    environment: import.meta.env.MODE,
    beforeSend(event) {
        if (event.user) {
            delete event.user.name
            delete event.user.email
            delete event.user.ip_address
        }
        return event
    },
})
